import { render, staticRenderFns } from "./pageGoodSpecification.vue?vue&type=template&id=1b96793c"
import script from "./pageGoodSpecification.vue?vue&type=script&lang=js"
export * from "./pageGoodSpecification.vue?vue&type=script&lang=js"
import style0 from "./pageGoodSpecification.vue?vue&type=style&index=0&id=1b96793c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports